import React from 'react';
import i18n from 'i18next';
import Folder from '@mui/icons-material/Folder';
import Search from '@mui/icons-material/Search';

import { Filter, NestedListContainer } from '@/exceed';

import { Loading } from 'uikit/loaders';
import { TextInput } from 'uikit/inputs';
import { Typo } from 'uikit/content';

import TopicChips from './topicChips';
import TopicTagMappingListContainer from '../containers/topicTagMappingListContainer';

import styles from '../styles/topicTagMapping.module.scss';

const TopicTagMapping = ({
  allTopics,
  hasSearch,
  id = 'topic-tag-mapping',
  isInitiallyExpanded,
  isLoading,
  locale,
  locales,
  onLocaleChange,
  onSearchInputChange,
  onTopicSelectionUpdate,
  searchInputValue,
  topics,
  topicSelection,
}) => {
  const topicsText = i18n.t('topics');

  return (
    <NestedListContainer
      bodyAriaLabel={topicsText}
      bodyClassName={styles.bodyContainer}
      expandedClassName={styles.isExpanded}
      header={(
        <div className={styles.headerInner}>
          <Folder className={styles.icon} sx={{ height: 20, width: 20 }} />
          <Typo className={styles.title} weight="medium">{topicsText}</Typo>
        </div>
      )}
      headerClassName={styles.header}
      id={id}
      initialExpandedIds={isInitiallyExpanded ? [id] : []}
      toggleButtonSize="xsmall"
    >
      <div className={styles.body}>
        <div className={styles.section}>
          <TextInput
            className={styles.search}
            icon={<Search />}
            id="topic-tags"
            onChange={onSearchInputChange}
            placeholder={i18n.t('search-topics')}
            value={searchInputValue}
          />
          <Filter
            isSingleSelect
            name={i18n.t('locale')}
            onSelectionUpdate={onLocaleChange}
            options={locales}
            param="locale"
            selection={[locale]}
          />
        </div>
        <div className={styles.section}>
          {isLoading ? <Loading className={styles.loader} /> : (
            <TopicTagMappingListContainer
              allTopics={allTopics}
              hasSearch={hasSearch}
              onTopicSelectionUpdate={onTopicSelectionUpdate}
              topics={topics}
              topicSelection={topicSelection}
            />
          )}
        </div>
        <div className={styles.section}>
          <TopicChips topics={topicSelection} />
        </div>
      </div>
    </NestedListContainer>
  );
};

export default React.memo(TopicTagMapping);
